import { Component, effect, ElementRef, input, viewChild } from '@angular/core';
import { Swiper, SwiperOptions } from 'swiper/types';
import { SwiperContainer } from 'swiper/element';
import { EXPERIENCE_GALLERY_SWIPER_CONFIG } from './experience-gallery-swiper-config';
import { IconService } from '@ess-front/shared';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'ess-experience-gallery',
  templateUrl: './experience-gallery.component.html',
  styleUrls: ['./experience-gallery.component.scss'],
  standalone: false,
})
export class ExperienceGalleryComponent {
  title = input('');
  gallery = input.required<string[]>();
  swiperContainer = viewChild<ElementRef<SwiperContainer>>('swiper');

  config: SwiperOptions = EXPERIENCE_GALLERY_SWIPER_CONFIG;
  currentSlide = 0;
  nextArrowIcon: SafeHtml | null;
  prevArrowIcon: SafeHtml | null;

  constructor(private iconService: IconService) {
    this.nextArrowIcon = this.iconService.getSVG('gallery_arrow_next');
    this.prevArrowIcon = this.iconService.getSVG('gallery_arrow_prev');
    effect(() => {
      const swiper = this.swiperContainer()?.nativeElement.swiper;
      if (swiper && this.gallery().length > 1) {
        this.prepareSwiperEvent(swiper);
      }
    });
  }

  nextSlide(): void {
    const swiper = this.swiperContainer()?.nativeElement.swiper;
    if (swiper) {
      swiper.slideNext();
    }
  }

  prevSlide(): void {
    const swiper = this.swiperContainer()?.nativeElement.swiper;
    if (swiper) {
      swiper.slidePrev();
    }
  }

  private prepareSwiperEvent(swiper: Swiper): void {
    swiper.on('slideChange', (swiper: Swiper) => {
      this.currentSlide = swiper.realIndex % this.gallery().length;
    });
  }
}
